import store from '@/store';
import apiInstance from '../../axios/axios';

const state = {
  events: null,
};

const getters = {
  events(state) {
    return state.events;
  },
};

const actions = {
  async getEvents({ commit }, payload) {
    try {
      const res = await apiInstance.get('getEvents');
      commit('setEvents', res.data.data.payload);
    } catch (error) {
      console.log(error);
    }
  },
};

const mutations = {
  setEvents(state, payload) {
    state.events = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
